import {
  AffiliateCommissionKind,
  AffiliateCommissionStatus,
  AffiliateReconciliationState,
  AffiliateReferralReviewState,
  AffiliateRegime,
  AffiliateSource,
  AffiliateStatus,
} from '../affiliate';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_AFFILIATE_REGIME = 'AFFILIATE_REGIME_';
export const TRANSLATE_KEY_AFFILIATE_STATUS = 'AFFILIATE_STATUS_';
export const TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS = 'AFFILIATE_COMMISSION_STATUS_';
export const TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND = 'AFFILIATE_COMMISSION_KIND_';
export const TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE = 'AFFILIATE_RECONCILIATION_STATE_';
export const TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE = 'AFFILIATE_REFERRAL_REVIEW_STATE_';
export const TRANSLATE_KEY_AFFILIATE_SOURCE = 'AFFILIATE_SOURCE_';

export const AffiliateRegimeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_REGIME}${AffiliateRegime.CLIENT_PRO}`]: 'Client (réduction abo)',
    [`${TRANSLATE_KEY_AFFILIATE_REGIME}${AffiliateRegime.PARTICULIER}`]: 'Particulier (carte cadeau)',
    [`${TRANSLATE_KEY_AFFILIATE_REGIME}${AffiliateRegime.PRO_EXTERNE}`]: 'Pro externe (virement)',
  },
};

export const AffiliateStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_STATUS}${AffiliateStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_AFFILIATE_STATUS}${AffiliateStatus.ACTIVE}`]: 'Actif',
    [`${TRANSLATE_KEY_AFFILIATE_STATUS}${AffiliateStatus.SUSPENDED}`]: 'Suspendu',
  },
};

export const AffiliateCommissionStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS}${AffiliateCommissionStatus.REVIEW}`]: 'À valider',
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS}${AffiliateCommissionStatus.PENDING}`]: 'À verser',
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS}${AffiliateCommissionStatus.PAID}`]: 'Versée',
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS}${AffiliateCommissionStatus.VOID}`]: 'Annulée',
  },
};

export const AffiliateCommissionKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND}${AffiliateCommissionKind.COMMISSION}`]: 'Commission',
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND}${AffiliateCommissionKind.OPENING_BALANCE}`]: "Solde d'ouverture",
    [`${TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND}${AffiliateCommissionKind.ADJUSTMENT}`]: 'Ajustement',
  },
};

export const AffiliateReconciliationStateTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE}${AffiliateReconciliationState.PENDING}`]: 'À rapprocher',
    [`${TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE}${AffiliateReconciliationState.ATTACHED}`]: 'Rattaché',
    [`${TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE}${AffiliateReconciliationState.IGNORED}`]: 'Ignoré',
  },
};

export const AffiliateReferralReviewStateTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE}${AffiliateReferralReviewState.PENDING}`]: 'À vérifier',
    [`${TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE}${AffiliateReferralReviewState.APPROVED}`]: 'Parrainage validé',
    [`${TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE}${AffiliateReferralReviewState.REJECTED}`]: 'Parrainage refusé',
  },
};

export const AffiliateSourceTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_AFFILIATE_SOURCE}${AffiliateSource.ADMIN}`]: 'Créé en interne',
    [`${TRANSLATE_KEY_AFFILIATE_SOURCE}${AffiliateSource.SELF_SIGNUP}`]: 'Inscription publique',
    [`${TRANSLATE_KEY_AFFILIATE_SOURCE}${AffiliateSource.PRO_APP}`]: 'Activé depuis l’app',
    [`${TRANSLATE_KEY_AFFILIATE_SOURCE}${AffiliateSource.IMPORT_FP}`]: 'Import FirstPromoter',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(AffiliateRegime, AffiliateRegimeTranslation, TRANSLATE_KEY_AFFILIATE_REGIME, true);
validateEnumTranslations(AffiliateStatus, AffiliateStatusTranslation, TRANSLATE_KEY_AFFILIATE_STATUS, true);
validateEnumTranslations(
  AffiliateCommissionStatus,
  AffiliateCommissionStatusTranslation,
  TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS,
  true,
);
validateEnumTranslations(
  AffiliateCommissionKind,
  AffiliateCommissionKindTranslation,
  TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND,
  true,
);
validateEnumTranslations(
  AffiliateReconciliationState,
  AffiliateReconciliationStateTranslation,
  TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE,
  true,
);
validateEnumTranslations(AffiliateSource, AffiliateSourceTranslation, TRANSLATE_KEY_AFFILIATE_SOURCE, true);
validateEnumTranslations(
  AffiliateReferralReviewState,
  AffiliateReferralReviewStateTranslation,
  TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE,
  true,
);
